import { useCallback, useEffect, useState } from 'react';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import './ZohoChatbot.scss';
import { useCookie } from '../utils/withCookie';

const SCRIPT_ID = 'zoho-chat-script';
const TWO_WEEKS = 60 * 60 * 24 * 14; // 2 weeks in seconds

const ZohoChatbot = () => {
  const [isZohoChatLoaded, setIsZohoChatLoaded] = useState(false);
  const isZohoChatExperiment =
    useSoyuzExperiment('ZohoChatbotV2').get('behaviour') === 'variant';
  const { getCookie, setCookie } = useCookie();

  const hasUsedSpottyCat = getCookie('SpottyCatUsed') !== undefined;

  const loadScripts = useCallback(() => {
    const scriptAlreadyInjected = document.querySelector(`#${SCRIPT_ID}`);

    if (scriptAlreadyInjected || !isZohoChatExperiment) {
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.defer = true;
    script.type = 'text/javascript';
    script.innerHTML =
      'window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}';
    document.body.appendChild(script);

    const scriptSrc = document.createElement('script');
    scriptSrc.defer = true;
    scriptSrc.type = 'text/javascript';
    scriptSrc.src =
      '//salesiq.zohopublic.com/widget?wc=siq05454a5f6626ff134ffe8042ca1fbb7f2505ed7276493711f51ad5ac9d30f99d';
    scriptSrc.onload = () => {
      setIsZohoChatLoaded(true);
    };
    document.body.appendChild(scriptSrc);
  }, [isZohoChatExperiment]);

  const addAlreadyUsedClass = () => {
    const zohoChatElement = document.querySelector('#zsiq_float');
    if (zohoChatElement) {
      zohoChatElement.classList.add('zsiq-custom-used');
    }
  };

  useEffect(() => {
    if (isZohoChatExperiment && !isZohoChatLoaded) {
      loadScripts();
    }
  }, [isZohoChatExperiment, isZohoChatLoaded, loadScripts]);

  useEffect(() => {
    if (!isZohoChatExperiment || !isZohoChatLoaded) {
      return;
    }

    window.$zoho.salesiq.afterReady = () => {
      window.$zoho.salesiq.chat.online(() => {
        if (hasUsedSpottyCat) {
          addAlreadyUsedClass();
        }
      });

      window.$zoho.salesiq.chatbutton.click(() => {
        setCookie('SpottyCatUsed', 1, { maxAge: TWO_WEEKS });
        addAlreadyUsedClass();
        SoyuzAnalytics.sendGA4Event('send', {
          context: 'ZohoChat',
          action: 'Open',
          value: 'click'
        });
      });

      window.$zoho.salesiq.floatwindow.close(() => {
        SoyuzAnalytics.sendGA4Event('send', {
          context: 'ZohoChat',
          action: 'Close',
          value: 'click'
        });
      });
    };
  }, [isZohoChatExperiment, isZohoChatLoaded, hasUsedSpottyCat, setCookie]);

  return null;
};

export default ZohoChatbot;
